import {
    HeaderWrap,
    HeaderTop,
    HeaderTopLeft,
    LogoLink,
    Logo,
    HeaderTopRight,
    HeaderFlex,
    LogoList,
    LogoItem,
    HeaderTopMenu,
    HeaderTopItem,
    HeaderTopLink,
    HotlineIcon,
    UserIcon,
    Separate,
    ProfileLink,
    Avatar,
    Username,
    UserMenu,
    UserMenuItem,
    UserMenuLink,
    HeaderMiddle,
    MainLogo,
    HeaderMiddleMenu,
    HeaderMiddleItem,
    HeaderMiddleLink,
    BellIcon,
    HeaderBottom,
    HeaderBottomMenu,
    HeaderBottomMenuItem,
    HeaderBottomMenuLink,
    CallButton,
    Bars,
    Bar,
    PhoneIc,
    TabletMenu,
    TabletCategory,
    CategoryLink,
    MobileButtons,
    YoutubeButton,
    PhoneButton,
    SearchButton,
    MobileButton,
    FacebookButton,
    MobileOverlay,
    MobileSearchInput,
    MobileCateLink,
    MenuOverlay,
    MbSearchForm,
    MbSeachSubmit,
    SearchIc,
    PersonIc,
    HelloUser,
    UserMobileMenu,
    UserMobileItem,
    UserMobileLink
} from './headerElements'
import { MyContainer } from '../common/MyContainer'
import logoData from '../../data/logo'
import AuthForm from '../authForm'
import { useDispatch, useSelector } from 'react-redux'
import { openFormLogin, openFormRegister } from '../../store/reducer/authFormSlice'
import { logout } from '../../store/reducer/userSlice'
import bell from '../../assets/images/bell.svg'
import mainLogo from '../../assets/images/sprite-tto_v2.webp'
import SearchForm from '../searchForm'
import miniIcon from '../../assets/images/16@2x.webp'
import {SELECT_CATEGORY_OPTIONS} from '../../global'
import Banner from '../banner'
import queryString from 'query-string';
import { useState, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

const Header = ({hide, hidebanner, menuMt}) => {
    const dispatch = useDispatch()
    const { user, isAuthenticated } = useSelector(state => state.user)
    const [showTabletMenu, setShowTabletMenu] = useState(false)
    const [innerWidth, setInnerWidth] = useState(window.innerWidth)
    const [showMbSearch, setShowMobileSearch] = useState(false)
    const [mbSearchValue, setMbSearchValue] = useState('')
    const history = useHistory()

    const handleToggleSearch = e => {
        e.preventDefault()
        setShowMobileSearch(!showMbSearch)
    }


    useEffect(() => {
        const handleResize = () => setInnerWidth(window.innerWidth)
        window.addEventListener('resize', handleResize)

        return () => window.removeEventListener('resize', handleResize)
    }, [])

    const handleShowMenu = () => setShowTabletMenu(!showTabletMenu)

    const showLoginForm = e => {
        e.preventDefault()
        dispatch(openFormLogin());
    }

    const showRegisterForm = e => {
        e.preventDefault()
        dispatch(openFormRegister());
    }

    const handleLogout = async e => {
        e.preventDefault()
        try {
            await dispatch(logout())
        } catch (error) {
            console.log(error)
        }
    }

    const handleMbSearchChange = e => setMbSearchValue(e.target.value)

    const handleSubmitMbSearch = e => {
        e.preventDefault()

        if(!mbSearchValue) return

        history.push({
            pathname: '/search',
            search: `?q=${mbSearchValue}`
        })
        setShowMobileSearch(false)
        setMbSearchValue('')
    }

    return (
        <>
            {innerWidth < 768 &&
                <>
                    <MobileOverlay show={showMbSearch} onClick={handleToggleSearch} />
                    <MbSearchForm onSubmit={handleSubmitMbSearch} show={showMbSearch}>
                        <MobileSearchInput onChange={handleMbSearchChange} value={mbSearchValue} placeholder='Tìm Kiếm' type='text' />
                        <MbSeachSubmit><SearchIc /></MbSeachSubmit>
                    </MbSearchForm>
                </>
            }
            <AuthForm />
            <MenuOverlay onClick={handleShowMenu} className={showTabletMenu && 'show'}></MenuOverlay>
            <HeaderWrap>
                <HeaderTop className='hide-on-mobile'>
                    <MyContainer>
                        <HeaderFlex>
                            <HeaderTopLeft>
                                <LogoList>
                                    {
                                        logoData.map((item, index) => (
                                            <LogoItem key={index}>
                                                <LogoLink title={item.title} to={item.path}>
                                                    <Logo style={item.style} src={item.image} alt={item.title} />
                                                </LogoLink>
                                            </LogoItem>
                                        ))
                                    }
                                </LogoList>
                            </HeaderTopLeft>
                            <HeaderTopRight>
                                <HeaderTopMenu>
                                    <HeaderTopItem className='hide-on-mobile-tablet'>
                                        <HeaderTopLink title="Hotline" to="/">Hotline: 0918.033.133</HeaderTopLink>
                                    </HeaderTopItem>
                                    <HeaderTopItem className='hide-on-mobile-tablet'>
                                        <HeaderTopLink title="Đặt báo Tuổi Trẻ" to="/"><HotlineIcon /> Đặt báo</HeaderTopLink>
                                    </HeaderTopItem>
                                    <HeaderTopItem className='hide-on-mobile-tablet'>
                                        <HeaderTopLink title="Liên hệ Quảng cáo" to="/">Quảng cáo</HeaderTopLink>
                                    </HeaderTopItem>
                                    <HeaderTopItem>
                                        {isAuthenticated ? (<>
                                            <ProfileLink onClick={e => e.preventDefault()} to="/">
                                                <Avatar src={user.avatar} alt="avatar" />
                                                <Username>{user.username}</Username>
                                            </ProfileLink>
                                            <UserMenu>
                                                <UserMenuItem>
                                                    <UserMenuLink to="/me/news">Tin đã lưu</UserMenuLink>
                                                </UserMenuItem>
                                                <UserMenuItem>
                                                    <UserMenuLink to="/me/comments">Bình luận của bạn</UserMenuLink>
                                                </UserMenuItem>
                                                {user.isAdmin && (
                                                    <UserMenuItem>
                                                        <UserMenuLink to="/admin/news">Trang admin</UserMenuLink>
                                                    </UserMenuItem>
                                                )}
                                                <UserMenuItem>
                                                    <UserMenuLink to="/me/account">Cài đặt tài khoản</UserMenuLink>
                                                </UserMenuItem>
                                                <UserMenuItem>
                                                    <UserMenuLink onClick={handleLogout} to="/">Đăng xuất</UserMenuLink>
                                                </UserMenuItem>
                                            </UserMenu>
                                        </>):(<>
                                            <HeaderTopLink onClick={showLoginForm} title="Đăng nhập" to="/"><UserIcon /> Đăng nhập</HeaderTopLink>
                                            <Separate>|</Separate>
                                            <HeaderTopLink onClick={showRegisterForm} title="Đăng ký" to="/">Đăng ký</HeaderTopLink>
                                        </>)}
                                        
                                    </HeaderTopItem>
                                </HeaderTopMenu>
                            </HeaderTopRight>
                        </HeaderFlex>
                    </MyContainer>
                </HeaderTop>
                <HeaderMiddle>
                    <MyContainer>
                        <HeaderFlex>
                            <MainLogo style={{backgroundImage: `url(${mainLogo})`}} to="/" />
                            <HeaderMiddleMenu className='hide-on-mobile'>
                                <HeaderMiddleItem className='hide-on-mobile-tablet'>
                                    <HeaderMiddleLink className="switch" to="/">
                                    <BellIcon src={bell} alt="1" />
                                    Mời bạn đọc trải nghiệm giao diện mới
                                    </HeaderMiddleLink>
                                </HeaderMiddleItem>
                                <HeaderMiddleItem className='hide-on-mobile-tablet'>
                                    <HeaderMiddleLink to="/">YOUTUBE BÁO TUỔI TRẺ</HeaderMiddleLink>
                                </HeaderMiddleItem>
                                <HeaderMiddleItem>
                                    <HeaderMiddleLink className='hide-on-mobile-tablet' to="/">CẦN BIẾT</HeaderMiddleLink>
                                </HeaderMiddleItem>
                                <HeaderMiddleItem>
                                    <HeaderMiddleLink className='hide-on-mobile-tablet' to="/">NHÀ ĐẤT</HeaderMiddleLink>
                                </HeaderMiddleItem>
                            </HeaderMiddleMenu>
                            <SearchForm />
                            <MobileButtons className='hide-on-pc hide-on-tablet'>
                                <MobileButton><YoutubeButton href='https://www.youtube.com/' /></MobileButton>
                                <MobileButton><FacebookButton href='https://www.facebook.com/pqhuy2312/' /></MobileButton>
                                <MobileButton><PhoneButton href='#' /></MobileButton>
                                <MobileButton><SearchButton onClick={handleToggleSearch} to='/' /></MobileButton>
                            </MobileButtons>
                            <CallButton className='hide-on-pc hide-on-mobile' href='/'><PhoneIc /></CallButton>
                            <Bars onClick={handleShowMenu} className={showTabletMenu ? 'active hide-on-pc':'hide-on-pc'}>
                                <Bar />
                                <Bar />
                                <Bar />
                            </Bars>
                        </HeaderFlex>
                    </MyContainer>
                    <TabletMenu className={showTabletMenu ? 'hide-on-pc show':'hide-on-pc'}>
                        {isAuthenticated ? 
                        <TabletCategory style={{flexDirection: 'column', alignItems: 'flex-start'}}>
                            <HelloUser><PersonIc />Chào , {user.username}</HelloUser>
                            <UserMobileMenu>
                                <UserMobileItem>
                                    <UserMobileLink onClick={handleShowMenu} to='/me/news'>Tin đã lưu</UserMobileLink>
                                </UserMobileItem>
                                <UserMobileItem>
                                    <UserMobileLink onClick={handleShowMenu}  to='/me/comments'>Bình luận của bạn</UserMobileLink>
                                </UserMobileItem>
                                <UserMobileItem>
                                    <UserMobileLink onClick={handleShowMenu}  to='/me/account'>Cài đặt tài khoản</UserMobileLink>
                                </UserMobileItem>
                                <UserMobileItem>
                                    <UserMobileLink onClick={e => {
                                        handleShowMenu()
                                        handleLogout(e)
                                    }} to='/'>Đăng xuất tài khoản</UserMobileLink>
                                </UserMobileItem>
                            </UserMobileMenu>
                        </TabletCategory>:
                            <TabletCategory style={{padding: '8px 12px'}} className='mobile-auth'>
                                <MobileCateLink onClick={showLoginForm} title="Đăng nhập" to="/"><UserIcon /> Đăng nhập</MobileCateLink>
                                    <Separate>|</Separate>
                                <MobileCateLink onClick={showRegisterForm} title="Đăng ký" to="/">Đăng ký</MobileCateLink>
                            </TabletCategory>
                        }
                        {SELECT_CATEGORY_OPTIONS.map((item, index) => (
                            <TabletCategory key={index}>
                                <CategoryLink onClick={handleShowMenu} title={item.value} to={`/category/news?${queryString.stringify({category: item.value})}`}>{item.value}</CategoryLink>
                            </TabletCategory>
                        ))}
                    </TabletMenu>
                    
                </HeaderMiddle>
                <HeaderBottom hide={hide}>
                    <MyContainer>
                        <Banner hidebanner={hidebanner} image={innerWidth < 768 ? 'https://res.cloudinary.com/huyphamcloud/image/upload/v1628309985/tuoitre/640x-1624939886311_iwizwp.jpg':'https://res.cloudinary.com/huyphamcloud/image/upload/v1625485662/tuoitre/980x-1624939877672_x7rtc1.jpg'} />
                        <HeaderBottomMenu className='hide-on-mobile-tablet' menuMt={menuMt}>
                            <HeaderBottomMenuItem>
                                <HeaderBottomMenuLink title='Trang chủ' style={{background: `url(${miniIcon})`}} to='/'></HeaderBottomMenuLink>
                            </HeaderBottomMenuItem>
                            <HeaderBottomMenuItem>
                                <HeaderBottomMenuLink title='Media' to='/'>Media</HeaderBottomMenuLink>
                            </HeaderBottomMenuItem>
                            {SELECT_CATEGORY_OPTIONS.map((item, index) => (
                                <HeaderBottomMenuItem key={index}>
                                    <HeaderBottomMenuLink title={item.value} to={`/category/news?${queryString.stringify({category: item.value})}`}>{item.value}</HeaderBottomMenuLink>
                                </HeaderBottomMenuItem>
                            ))}
                        </HeaderBottomMenu>
                    </MyContainer>
                </HeaderBottom>
            </HeaderWrap>
        </>
    )
}

export default Header
